import Marquee from "react-fast-marquee";

const words = ["Wash", "Dry", "Fold", "Pickup", "Delivery", "Spintastic City"];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-[#E2DFD8] py-5"
    >
      <Marquee speed={18} gradient={false} pauseOnHover>
        {words.map((w) => (
          <span key={w} className="flex items-center">
            <span className="px-8 text-sm font-bold uppercase tracking-[0.35em] text-[#1A1A1A]">
              {w}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#C85C40]" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
